import {requestIdlePromise} from "@MAIN/vendor/requestIdleCallback";
import $liteReady from 'lite-ready'

const onWindowLoad = new Promise(resolve => {
  window.addEventListener('load', resolve)
})

const onDocumentReady = new Promise(resolve => {
  $liteReady(resolve)
})

export default onWindowLoad

const onWindowLoadAndIdle = onWindowLoad.then(requestIdlePromise)

export {
  onDocumentReady,
  onWindowLoad,
  onWindowLoadAndIdle
}
